export var Align = {
  Start: 'start',
  End: 'end',
  Center: 'center',
  Baseline: 'baseline',
  Stretch: 'stretch',
  Initial: 'initial',
  SpaceBetween: 'space-between',
  SpaceAround: 'space-around',
  SpaceEvenly: 'space-evenly'
};